import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
})
export class DurationPipe implements PipeTransform {
  transform(value: number | null, yearLabel: string, monthLabel: string): any {
    if (value === null) {
      return;
    }
    if (value < 12) {
      return `${value} ${monthLabel}`;
    }
    let years = 0;
    while (value >= 12) {
      years += 1;
      value = value - 12;
    }
    return `${years} ${yearLabel}${value > 0 ? ` ${value} ${monthLabel}` : ''}`;
  }
}
